import { render } from "./CoolLightBox.vue?vue&type=template&id=0f9b7b4e"
import script from "./CoolLightBox.vue?vue&type=script&lang=js"
export * from "./CoolLightBox.vue?vue&type=script&lang=js"

import "./CoolLightBox.vue?vue&type=style&index=0&id=0f9b7b4e&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\projects\\external\\kazigraphix\\admin.kazigraphix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__